var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: "list-invisible-training-stats",
              expression: "'list-invisible-training-stats'",
            },
          ],
          staticClass: "m-1",
          attrs: { variant: "info" },
        },
        [_vm._v("Statistiques de consultation")]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { id: "list-invisible-training-stats" } },
        [
          _c(
            "b-row",
            {
              staticClass: "justify-content-md-center mt-4",
              attrs: { "align-v": "center" },
            },
            [
              _c(
                "b-col",
                { attrs: { "align-self": "center" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Filtrer",
                                "label-cols-sm": "3",
                                "label-align-sm": "left",
                                "label-size": "sm",
                                "label-for": "filterInput",
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                { attrs: { size: "sm" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "filterInput",
                                      type: "search",
                                      placeholder:
                                        "Taper pour rechercher un document",
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function ($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { disabled: !_vm.filter },
                                          on: {
                                            click: function ($event) {
                                              _vm.filter = ""
                                            },
                                          },
                                        },
                                        [_vm._v("Effacer")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      fields: _vm.fields,
                      items: _vm.statsTraining,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                      small: "",
                      responsive: "sm",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(doc_id)",
                        fn: function (row) {
                          return [
                            _c("b-col", [_vm._v(_vm._s(row.item.doc_id))]),
                          ]
                        },
                      },
                      {
                        key: "cell(doc_name)",
                        fn: function (row) {
                          return [
                            _c("b-col", [
                              _vm._v(
                                _vm._s(
                                  `[${row.item.doc_type}] ${row.item.doc_name}`
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(doc_methods)",
                        fn: function (row) {
                          return [
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-2 mb-2",
                                style: { "background-color": _vm.OPEN },
                              },
                              [
                                _vm._v(
                                  "\n              Ouvert\n              "
                                ),
                                _c("b-badge", { attrs: { variant: "light" } }, [
                                  _vm._v(_vm._s(row.item.doc_methods.OPEN)),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-2 mb-2",
                                style: { "background-color": _vm.DOWNLOAD },
                              },
                              [
                                _vm._v(
                                  "\n              Téléchargé\n              "
                                ),
                                _c("b-badge", { attrs: { variant: "light" } }, [
                                  _vm._v(_vm._s(row.item.doc_methods.DOWNLOAD)),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-2 mb-2",
                                style: { "background-color": _vm.SHARE },
                              },
                              [
                                _vm._v(
                                  "\n              Partagé\n              "
                                ),
                                _c("b-badge", { attrs: { variant: "light" } }, [
                                  _vm._v(_vm._s(row.item.doc_methods.SHARE)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(doc_nb_concerned)",
                        fn: function (row) {
                          return [
                            _c("b-col", [
                              _vm._v(_vm._s(row.item.doc_nb_concerned)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }